import { Pressable, View, Text } from 'react-native'

type PricingOptionProps = {
  title: string
  price: React.ReactNode
  selected: boolean
  onPress: () => void
  savingBadge?: string
}

export default function PricingOption({
  title,
  price,
  selected,
  onPress,
  savingBadge
}: PricingOptionProps) {
  return (
    <Pressable
      className={`w-0 grow p-4 rounded-3xl border-2 relative ${selected ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-500/15' : 'border-gray-300 dark:border-gray-600 bg-secondary-system-grouped-background'}`}
      onPress={onPress}
    >
      {savingBadge && (
        <View className="absolute -top-3 left-1/2 -translate-x-1/2 bg-indigo-500 px-3 py-1 rounded-3xl">
          <Text className="text-white text-xs font-semibold">{savingBadge}</Text>
        </View>
      )}
      <View className="flex-row items-center justify-between">
        <View className="flex-1">
          <Text className="text-base font-bold mb-1 text-label">{title}</Text>
          {price}
        </View>
        <View className={`w-6 h-6 rounded-full border-2 items-center justify-center ${selected ? 'border-indigo-500 bg-indigo-500' : 'border-gray-400 dark:border-gray-500 bg-secondary-system-grouped-background'}`}>
          {selected && <Text className="text-white text-sm font-bold">✓</Text>}
        </View>
      </View>
    </Pressable>
  )
}
